import { render, staticRenderFns } from "./imei.vue?vue&type=template&id=890e7d66"
import script from "./imei.vue?vue&type=script&lang=js"
export * from "./imei.vue?vue&type=script&lang=js"
import style0 from "./imei.vue?vue&type=style&index=0&id=890e7d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports